export const LegendColors = {
  scope1_2: '#F08E8C',
  allScope: '#21E2BD'
};

export enum orgKey {
  scope1_2 = 'scope_1_2',
  allScope = 'allScope'
}

export const OrgChartLegendColors = [
  {label: 'Scope 1 & 2', key: orgKey.scope1_2, color: LegendColors.scope1_2},
  {label: 'Scope 1, 2 & 3', key: orgKey.allScope, color: LegendColors.allScope}
];
